import type { TMessages } from '@/types/TMessages'

export const messages = {
  fieldEvaluationReportDialog: {
    comment: 'Заявка на отчет из Журнала',
  },
} satisfies TMessages
